/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

// code to show the orange menu on mobile after initial scroll
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

// document.addEventListener('DOMContentLoaded', function () { 

//   const mobileBottom = document.querySelector('.header__mobile__bottom'); 
  
//   if (!mobileBottom) return; 
  
//   function handleMobileBottomNav() { const scrollY = window.scrollY; 
//       if (scrollY > 80) 
//         { mobileBottom.classList.add('is-visible'); } 
//       else 
//         { mobileBottom.classList.remove('is-visible'); } } 
      
//       window.addEventListener('scroll', handleMobileBottomNav, { passive: true }); 
// });

document.addEventListener('DOMContentLoaded', function () {
  const fakeSearch = document.querySelector('[data-open-mobile-search]');
  const realSearchDetails = document.querySelector(
    '.header__mobile__left header-search-popdown details'
  );

  if (!fakeSearch || !realSearchDetails) return;

  fakeSearch.addEventListener('click', function () {
    realSearchDetails.setAttribute('open', '');

    setTimeout(function () {
      const input = document.querySelector('#SearchInput--mobile');

      if (input) {
        input.removeAttribute('tabindex');
        input.setAttribute('tabindex', '0');
        input.focus();
      }
    }, 150);
  });
});



// single/pair, color swatches, variants, and ATC for collection pages

// single/pair, color swatches, variants, image swap, and ATC for collection pages

function ccFormatMoney(cents) {
  if (window.Shopify && Shopify.formatMoney) {
    return Shopify.formatMoney(cents);
  }

  return '$' + (cents / 100).toFixed(2);
}

function ccUpdateGridCardPrice(card) {
  const variantSelect = card.querySelector('[data-cc-variant-select]');
  const qtySelect = card.querySelector('[data-cc-qty-select]');
  const priceEl = card.closest('[data-grid-item]')?.querySelector('[data-product-price]');

  if (!variantSelect || !qtySelect || !priceEl) return;

  const selectedOption = variantSelect.options[variantSelect.selectedIndex];
  const variantPrice = Number(selectedOption.dataset.price || 0);
  const qty = Number(qtySelect.value || 1);

  priceEl.innerHTML = ccFormatMoney(variantPrice * qty);

  const singlePrice = card.querySelector('[data-cc-single-price]');
  const pairPrice = card.querySelector('[data-cc-pair-price]');

  if (singlePrice) singlePrice.textContent = ccFormatMoney(variantPrice);
  if (pairPrice) pairPrice.textContent = ccFormatMoney(variantPrice * 2);
}

function ccGetActiveColorFromCard(gridItem) {
  const activeSwatch = gridItem?.querySelector('[data-swatch-button].cc-color-selected');
  if (!activeSwatch) return null;

  return (
    activeSwatch.dataset.tooltip ||
    activeSwatch.querySelector('[data-swatch-text]')?.textContent?.trim() ||
    null
  );
}

function ccSelectVariantByOptions(card, colorValue, nonColorValue) {
  const variantSelect = card.querySelector('[data-cc-variant-select]');
  if (!variantSelect) return;

  const matchingOption = Array.from(variantSelect.options).find(function (option) {
    const fullTitle = option.textContent.trim().toLowerCase();
    const displayTitle = (option.dataset.displayTitle || '').trim().toLowerCase();

    const colorMatches = colorValue
      ? fullTitle.includes(colorValue.toLowerCase())
      : true;

    const nonColorMatches = nonColorValue
      ? displayTitle === nonColorValue.toLowerCase()
      : true;

    return colorMatches && nonColorMatches && !option.disabled;
  });

  if (matchingOption) {
    variantSelect.value = matchingOption.value;
    ccUpdateGridCardPrice(card);
  }
}

function ccUpdateGridImage(gridItem, swatchButton) {
  if (!gridItem || !swatchButton) return;

  // Desktop: update default product image from the pre-rendered variant image.
  const variantTitle = swatchButton.dataset?.swatchVariantName;

  if (variantTitle && window.CSS && CSS.escape) {
    const match = gridItem.querySelector(
      '.product-item__bg__inner[data-variant-title="' + CSS.escape(variantTitle) + '"] img'
    );

    const defaultImg = gridItem.querySelector('[data-product-image-default] img');

    if (match && defaultImg) {
      defaultImg.src = match.src;
      defaultImg.removeAttribute('srcset');
      defaultImg.removeAttribute('sizes');
    }
  }

  // Mobile: update only the active slide image.
  const swatchImage = swatchButton.dataset?.swatchImage;

  if (swatchImage) {
    const imageUrl = swatchImage.startsWith('//')
      ? swatchImage
      : '//cordsclub.com/cdn/shop/' + swatchImage;

    const activeSlide =
      gridItem.querySelector('.product-item__bg__slide.is-selected') ||
      gridItem.querySelector('.product-item__bg__slide');

    if (activeSlide) {
      const img = activeSlide.querySelector('img');

      if (img) {
        img.src = imageUrl;
        img.removeAttribute('srcset');
      }
    }
  }
}

function ccHandleSwatchSelection(event) {
  const swatchLink = event.target.closest('[data-swatch-link]');
  if (!swatchLink) return;

  event.preventDefault();
  event.stopPropagation();

  const swatchButton = swatchLink.closest('[data-swatch-button]');
  const gridItem = swatchLink.closest('[data-grid-item]');
  const card = gridItem?.querySelector('[data-cc-grid-cart]');

  if (!swatchButton || !gridItem || !card) return;

  gridItem.querySelectorAll('[data-swatch-button]').forEach(function (item) {
    item.classList.remove('cc-color-selected');
  });

  swatchButton.classList.add('cc-color-selected');
  ccUpdateGridImage(gridItem, swatchButton);

  const colorValue =
    swatchButton.dataset.tooltip ||
    swatchButton.querySelector('[data-swatch-text]')?.textContent?.trim();

  const visibleVariantDropdown = card.querySelector('[data-cc-variant-display-select]');
  const nonColorValue = visibleVariantDropdown ? visibleVariantDropdown.value : null;

  ccSelectVariantByOptions(card, colorValue, nonColorValue);
}

// Native select / qty price updates
document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-cc-variant-select], [data-cc-qty-select]')) return;

  const card = event.target.closest('[data-cc-grid-cart]');
  if (!card) return;

  ccUpdateGridCardPrice(card);
});

// Visible non-color variant dropdown
document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-cc-variant-display-select]')) return;

  const card = event.target.closest('[data-cc-grid-cart]');
  if (!card) return;

  const gridItem = card.closest('[data-grid-item]');
  const selectedDisplayTitle = event.target.value;
  const selectedColor = ccGetActiveColorFromCard(gridItem);

  ccSelectVariantByOptions(card, selectedColor, selectedDisplayTitle);
});

// Mobile fix: capture swatch before theme tooltip consumes first tap
document.addEventListener('pointerdown', function (event) {
  if (!event.target.closest('[data-swatch-link]')) return;

  ccHandleSwatchSelection(event);
}, true);

// Safety fallback for desktop clicks
document.addEventListener('click', function (event) {
  if (!event.target.closest('[data-swatch-link]')) return;

  ccHandleSwatchSelection(event);
}, true);

// Single / Pair dropdown
document.addEventListener('click', function (event) {
  const pairOption = event.target.closest('[data-cc-pair-option]');
  const pairDropdown = event.target.closest('[data-cc-pair-dropdown]');

  document.querySelectorAll('[data-cc-pair-dropdown].active_dps').forEach(function (dropdown) {
    if (!dropdown.contains(event.target)) {
      dropdown.classList.remove('active_dps');
    }
  });

  if (pairOption) {
    const dropdown = pairOption.closest('[data-cc-pair-dropdown]');
    const card = pairOption.closest('[data-cc-grid-cart]');
    const qtyInput = dropdown.querySelector('[data-cc-qty-select]');
    const label = dropdown.querySelector('[data-cc-pair-label]');

    qtyInput.value = pairOption.dataset.value;
    label.textContent = pairOption.dataset.name;

    dropdown.classList.remove('active_dps');

    ccUpdateGridCardPrice(card);
    return;
  }

  if (pairDropdown) {
    pairDropdown.classList.toggle('active_dps');
  }
});

// Add to cart
document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-cc-add-to-cart]');
  if (!button) return;

  const card = button.closest('[data-cc-grid-cart]');
  const variantSelect = card.querySelector('[data-cc-variant-select]');
  const qtySelect = card.querySelector('[data-cc-qty-select]');

  if (!variantSelect || !qtySelect) return;

  button.disabled = true;
  button.textContent = 'ADDING...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantSelect.value),
        quantity: Number(qtySelect.value || 1)
      })
    });

    if (!response.ok) throw new Error('Add to cart failed');

    button.textContent = 'ADDED';

    document.dispatchEvent(new CustomEvent('theme:cart:reload'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  } catch (error) {
    button.textContent = 'ERROR';
    console.error(error);
  }

  setTimeout(function () {
    button.disabled = false;
    button.textContent = 'ADD TO CART';
  }, 1200);
});

// Initial setup
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-grid-item]').forEach(function (gridItem) {
    const firstSwatch = gridItem.querySelector('[data-swatch-button]');

    if (firstSwatch && !gridItem.querySelector('[data-swatch-button].cc-color-selected')) {
      firstSwatch.classList.add('cc-color-selected');
    }
  });

  document.querySelectorAll('[data-cc-grid-cart]').forEach(function (card) {
    const gridItem = card.closest('[data-grid-item]');
    const selectedColor = gridItem ? ccGetActiveColorFromCard(gridItem) : null;
    const visibleVariantDropdown = card.querySelector('[data-cc-variant-display-select]');
    const nonColorValue = visibleVariantDropdown ? visibleVariantDropdown.value : null;

    ccSelectVariantByOptions(card, selectedColor, nonColorValue);
    ccUpdateGridCardPrice(card);
  });
});


// js code for wrapping atc btn and wishlist button in a parent container

document.addEventListener('DOMContentLoaded', function () {

  const addToCartBlock = document.querySelector('.product__block--buttons');

  const wishlistButtonContainer = document.querySelector('.swym-atw-button-container');

  if (!addToCartBlock || !wishlistButtonContainer) return;

  // Find the parent app block automatically
  const wishlistBlock = wishlistButtonContainer.closest('.shopify-app-block');

  if (!wishlistBlock) return;

  // Prevent duplicate initialization
  if (addToCartBlock.parentNode.classList.contains('pdp-buttons-wrapper')) return;

  // Create wrapper
  const wrapper = document.createElement('div');
  wrapper.className = 'pdp-buttons-wrapper';

  // Insert wrapper before the Add To Cart block
  addToCartBlock.parentNode.insertBefore(wrapper, addToCartBlock);

  // Move both elements inside wrapper
  wrapper.appendChild(addToCartBlock);
  wrapper.appendChild(wishlistBlock);

});


//pricing A/B changes

if (!window.__ccPairPricingLoaded) {
  window.__ccPairPricingLoaded = true;

  window.addEventListener("load", function () {
    function formatMoney(num) {
      return `$${Number(num).toFixed(2)}`;
    }

    function getNumber(text) {
      const n = parseFloat(String(text || "").replace(/[^0-9.]/g, ""));
      return Number.isFinite(n) ? n : null;
    }

    function setTextIfDifferent(el, value) {
      if (el && el.textContent.trim() !== value) {
        el.textContent = value;
      }
    }

    function setHtmlIfDifferent(el, value) {
      if (!el) return;

      const current = el.innerHTML.replace(/\s+/g, " ").trim();
      const next = value.replace(/\s+/g, " ").trim();

      if (current !== next) {
        el.innerHTML = value;
      }
    }

    window.ccPdpSelected = window.ccPdpSelected || "pair";

    const EXCLUDED_COLLECTION_HANDLES = [
      "dolphin-flat-back-stud-right",
      "mini-skeleton-hand-flat-back-stud",
      "pumpkin-pie-enamel-flat-back-stud",
      "toasted-mallow-enamel-flat-back-stud",
      "number-flat-back-studs"
    ];

function cardMatches(card) {
  const possibleText = [
    card.getAttribute("data-url"),
    card.querySelector(".product-link[href]")?.getAttribute("href"),
    card.querySelector(".product-link[data-product-link]")?.getAttribute("data-product-link"),
    card.querySelector("[data-quick-add-modal-handle]")?.getAttribute("data-quick-add-modal-handle"),
    card.querySelector("[data-swatch-handle]")?.getAttribute("data-swatch-handle"),
    ...Array.from(card.querySelectorAll("a[href]")).map(a => a.getAttribute("href"))
  ]
    .filter(Boolean)
    .join(" ");

  if (!possibleText.includes("flat-back-stud")) return false;

  return !EXCLUDED_COLLECTION_HANDLES.some((handle) =>
    possibleText.includes(handle)
  );
}

    function selectPairButton(selector) {
      const pairButton = document.querySelector(selector);

      if (pairButton) {
        pairButton.click();
        window.ccPdpSelected = "pair";
        return true;
      }

      return false;
    }

    const pdpDesktopPairInterval = setInterval(() => {
      if (selectPairButton(".r-ce7u3w")) clearInterval(pdpDesktopPairInterval);
    }, 300);

    const pdpMobilePairInterval = setInterval(() => {
      if (selectPairButton(".r-1usadv0")) clearInterval(pdpMobilePairInterval);
    }, 300);

    setTimeout(() => {
      clearInterval(pdpDesktopPairInterval);
      clearInterval(pdpMobilePairInterval);
    }, 6000);

    document.addEventListener("click", function (event) {
      if (event.target.closest(".r-ce7u3w, .r-1usadv0, [data-pair-button]")) {
        window.ccPdpSelected = "pair";
      }

      if (
        event.target.closest(
          ".r-1r08zu, .r-1uuskjb, [data-single-btn], [aria-label='atc-section-1'] [data-replo-price='true']:not([data-pair-button])"
        )
      ) {
        window.ccPdpSelected = "single";
      }
    });

    function getTrueBasePrice(productId, pairSpan) {
      let trueBasePrice = getNumber(pairSpan?.dataset.ccTrueBasePrice);

      if (trueBasePrice != null) return trueBasePrice;

      const nonStickySingle = document.querySelector(
        `[aria-label="atc-section-2"] [data-single-btn="${productId}"] span`
      );

      if (nonStickySingle) {
        trueBasePrice = getNumber(nonStickySingle.textContent);
      }

      if (trueBasePrice == null) {
        trueBasePrice = getNumber(pairSpan?.dataset.originalPrice);
      }

      if (trueBasePrice == null) {
        trueBasePrice = getNumber(pairSpan?.textContent) / 2;
      }

      return trueBasePrice;
    }

    function updatePdpPrices() {
      const pairWrappers = document.querySelectorAll("div[data-pair-button]");

      pairWrappers.forEach((pairWrapper) => {
        const pairSpan = pairWrapper.querySelector("span");
        if (!pairSpan) return;

        const productId = pairWrapper.dataset.pairButton;
        if (!productId) return;

        const trueBasePrice = getTrueBasePrice(productId, pairSpan);
        if (trueBasePrice == null || isNaN(trueBasePrice)) return;

        const pairComparePrice = trueBasePrice * 2;
        const pairDiscountPrice = pairComparePrice * 0.9;
        const discountedHalf = (pairDiscountPrice / 2).toFixed(2);

        pairSpan.dataset.ccTrueBasePrice = String(trueBasePrice);
        pairSpan.dataset.originalPrice = discountedHalf;

        document
          .querySelectorAll(`[data-pair-button="${productId}"] span`)
          .forEach((span) => {
            span.dataset.ccTrueBasePrice = String(trueBasePrice);
            span.dataset.originalPrice = discountedHalf;
            setTextIfDifferent(span, formatMoney(pairDiscountPrice));
          });

        document
          .querySelectorAll(`[data-single-btn="${productId}"] span`)
          .forEach((singleSpan) => {
            setTextIfDifferent(singleSpan, formatMoney(trueBasePrice));
          });

        document
          .querySelectorAll(
            `[data-product-id="${productId}"][data-replo-price="true"] span`
          )
          .forEach((singleSpan) => {
            const wrapper = singleSpan.closest('[data-replo-price="true"]');
            if (!wrapper || wrapper.hasAttribute("data-pair-button")) return;

            setTextIfDifferent(singleSpan, formatMoney(trueBasePrice));
          });

        const mainPriceElements = document.querySelectorAll(
          ".r-7fj8r5, .r-gkaie6, .r-kq20sf"
        );

        mainPriceElements.forEach((priceElement) => {
          if (window.ccPdpSelected === "pair") {
            setHtmlIfDifferent(
              priceElement,
              `
                <span style="text-decoration: line-through; opacity: 0.7; margin-right: 8px;">
                  ${formatMoney(pairComparePrice)}
                </span>
                <span>
                  ${formatMoney(pairDiscountPrice)}
                </span>
              `
            );
          } else {
            setHtmlIfDifferent(
              priceElement,
              `<span>${formatMoney(trueBasePrice)}</span>`
            );
          }
        });
      });
    }

    setInterval(updatePdpPrices, 150);

function getCollectionPrices(card) {
  const option = card.querySelector(
    "[data-cc-variant-select] option[selected]"
  ) || card.querySelector(
    "[data-cc-variant-select] option"
  );

  if (!option) return null;

  const singlePrice = Number(option.dataset.price) / 100;

  return {
    singlePrice,
    pairComparePrice: singlePrice * 2,
    pairDiscountPrice: singlePrice * 2 * 0.9
  };
}

function renderCollectionPairPrice(card) {
  const prices = getCollectionPrices(card);
  if (!prices) return;

  const mainPrice = card.querySelector(
    ".product-item__price[data-product-price]"
  );

  const pairButton = card.querySelector(".pair-button");
  const pairPriceSpan = pairButton?.querySelector("span");

  if (mainPrice) {
    setHtmlIfDifferent(
      mainPrice,
      `
      <span style="text-decoration: line-through; opacity:.6; margin-right:6px;">
        ${formatMoney(prices.pairComparePrice)}
      </span>
      <span>
        ${formatMoney(prices.pairDiscountPrice)}
      </span>
    `
    );
  }

  if (pairPriceSpan) {
    setTextIfDifferent(
      pairPriceSpan,
      formatMoney(prices.pairDiscountPrice)
    );
  }
}

function renderCollectionSinglePrice(card) {
  const prices = getCollectionPrices(card);
  if (!prices) return;

  const mainPrice = card.querySelector(
    ".product-item__price[data-product-price]"
  );

  if (mainPrice) {
    setHtmlIfDifferent(
      mainPrice,
      `<span>${formatMoney(prices.singlePrice)}</span>`
    );
  }
}

    function updateCollectionCardToPair(card) {
      if (!cardMatches(card)) return;

      const dropdownLabel = card.querySelector("[data-cc-pair-label], .all_btn_cs_dropdown");
      const pairButton = card.querySelector(".pair-button");
      const singleButton = card.querySelector(".single-button");
      const atcButton = card.querySelector("[data-cc-add-to-cart], .cc-grid-cart__button");
      const qtyInput = card.querySelector("[data-cc-qty-select]");

      if (!dropdownLabel || !pairButton || !singleButton || !atcButton) return;
      if (card.dataset.ccManualSelection === "single") return;

      const prices = getCollectionPrices(card);
      if (!prices) return;

      setTextIfDifferent(dropdownLabel, "Pair");

      atcButton.setAttribute("data-value", "2");

      if (qtyInput) {
        qtyInput.value = "2";
        qtyInput.setAttribute("value", "2");
      }

      singleButton.classList.remove("active");
      pairButton.classList.add("active");

      const singlePriceSpan = singleButton.querySelector("span");

      if (singlePriceSpan) {
        setHtmlIfDifferent(singlePriceSpan, formatMoney(prices.singlePrice));
      }

      renderCollectionPairPrice(card);
      card.dataset.ccPairDefaultApplied = "true";
    }

    function updateAllCollectionCards() {
      document
        .querySelectorAll("grid-item.product-item")
        .forEach(updateCollectionCardToPair);
    }

    updateAllCollectionCards();

    setInterval(updateAllCollectionCards, 1000);

    const collectionObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches?.(".grid-item.product-item")) {
            updateCollectionCardToPair(node);
          }

          node
            .querySelectorAll?.(".grid-item.product-item")
            .forEach(updateCollectionCardToPair);
        });
      });
    });

    if (document.body) {
      collectionObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

document.addEventListener("click", function (event) {
  const button = event.target.closest(".single-button, .pair-button");
  if (!button) return;

  const card = button.closest("grid-item.product-item");
  if (!card || !cardMatches(card)) return;

  const dropdownLabel = card.querySelector("[data-cc-pair-label], .all_btn_cs_dropdown");
  const atcButton = card.querySelector("[data-cc-add-to-cart], .cc-grid-cart__button");
  const qtyInput = card.querySelector("[data-cc-qty-select]");
  const singleButton = card.querySelector(".single-button");
  const pairButton = card.querySelector(".pair-button");

  if (!dropdownLabel || !atcButton || !singleButton || !pairButton) return;

  setTextIfDifferent(dropdownLabel, button.dataset.name);
  atcButton.setAttribute("data-value", button.dataset.value);

  if (qtyInput) {
    qtyInput.value = button.dataset.value;
    qtyInput.setAttribute("value", button.dataset.value);
  }

  if (button.classList.contains("single-button")) {
    card.dataset.ccManualSelection = "single";

    singleButton.classList.add("active");
    pairButton.classList.remove("active");

    renderCollectionSinglePrice(card);
  }

  if (button.classList.contains("pair-button")) {
    card.dataset.ccManualSelection = "pair";

    singleButton.classList.remove("active");
    pairButton.classList.add("active");

    renderCollectionPairPrice(card);
  }
});

    function forceTwoDecimalsOnAllVisiblePrices() {
      const selectors = [
        "[data-pair-button] span",
        "[data-single-btn] span",
        "[data-replo-price='true'] span",
        ".r-7fj8r5 span",
        ".r-gkaie6 span",
        ".r-kq20sf span"
      ];

      document.querySelectorAll(selectors.join(",")).forEach((span) => {
        const price = getNumber(span.textContent);
        if (price == null) return;

        setTextIfDifferent(span, formatMoney(price));
      });
    }

    setInterval(forceTwoDecimalsOnAllVisiblePrices, 300);
  });
}

// code for fixing the wishlist icon not showing on products loaded after the first scroll

document.addEventListener('DOMContentLoaded', function () {
  const collectionPage = document.querySelector('collection-component');
  if (!collectionPage) return;

  const initSwymObserver = function () {
    const grid = collectionPage.querySelector(
      '[data-collection-products], [data-products-grid], [data-grid], .collection__products'
    );

    if (!grid) return;

    let timer;
    let lastRun = 0;

    const observer = new MutationObserver(function (mutations) {
      const hasNewProductCard = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (
            node.matches?.('product-item, grid-item, [data-grid-item]') ||
            node.querySelector?.('product-item, grid-item, [data-grid-item]')
          );
        });
      });

      if (!hasNewProductCard) return;

      clearTimeout(timer);

      timer = setTimeout(function () {
        const now = Date.now();

        if (now - lastRun < 1500) return;

        lastRun = now;

        document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
      }, 700);
    });

    observer.observe(grid, {
      childList: true,
      subtree: true
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(initSwymObserver);
  } else {
    setTimeout(initSwymObserver, 1500);
  }
});

// intercom chat icon position changes

(function () {
  'use strict';

  var CONFIG = {
    alignment: 'right',
    horizontal_padding: 24,
    vertical_padding: 100,
    bottom: '100px',
    right: '12px'
  };

  var SELECTORS = [
    '.intercom-lightweight-app',
    '.intercom-lightweight-app-launcher',
    'iframe#intercom-launcher-frame'
  ].join(', ');

  // 1) Set before Intercom boots (most important)
  window.intercomSettings = Object.assign(window.intercomSettings || {}, {
    alignment: CONFIG.alignment,
    horizontal_padding: CONFIG.horizontal_padding,
    vertical_padding: CONFIG.vertical_padding
  });

  // 2) Persistent CSS layer (survives re-renders)
  if (!document.getElementById('cc-intercom-position')) {
    var style = document.createElement('style');
    style.id = 'cc-intercom-position';
    style.textContent =
      SELECTORS +
      '{bottom:' + CONFIG.bottom + '!important;right:' + CONFIG.right +
      '!important;left:auto!important;transform:none!important;}';
    document.head.appendChild(style);
  }

  function updateViaApi() {
    if (typeof window.Intercom !== 'function') return false;
    window.Intercom('update', {
      alignment: CONFIG.alignment,
      horizontal_padding: CONFIG.horizontal_padding,
      vertical_padding: CONFIG.vertical_padding
    });
    return true;
  }

  function applyDomStyles() {
    document.querySelectorAll(SELECTORS).forEach(function (el) {
      el.style.setProperty('bottom', CONFIG.bottom, 'important');
      el.style.setProperty('right', CONFIG.right, 'important');
      el.style.setProperty('left', 'auto', 'important');
      el.style.setProperty('transform', 'none', 'important');
    });
  }

  function enforce() {
    updateViaApi();
    applyDomStyles();
  }

  // 3) Debounced observer (avoid thrashing)
  var observerTimer;
  function scheduleEnforce() {
    clearTimeout(observerTimer);
    observerTimer = setTimeout(enforce, 16);
  }

  enforce();

  new MutationObserver(scheduleEnforce).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  // 4) Win the race during Intercom boot (first ~20s)
  var bootPoll = setInterval(function () {
    enforce();
  }, 500);

  setTimeout(function () {
    clearInterval(bootPoll);
  }, 20000);

  // 5) Light maintenance after boot (catches late resets)
  setInterval(enforce, 5000);

  window.addEventListener('load', enforce);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) enforce();
  });
})();


// hide houseplant collection bundle price on collection and PDP page

(function () {
  const PRODUCT_HANDLE = 'houseplant-flat-back-bundle';

  function hideBundlePrice() {
    // Product page
    if (window.location.pathname.includes(`/products/${PRODUCT_HANDLE}`)) {
      document.querySelectorAll('.product__price__wrap').forEach(el => {
        el.style.display = 'none';
      });
    }

    // Collection page
    document.querySelectorAll(`a[href*="/products/${PRODUCT_HANDLE}"]`).forEach(link => {
      const card = link.closest('grid-item');

      if (!card) return;

      card.querySelectorAll('.product-variant-and-price').forEach(el => {
        el.style.display = 'none';
      });
    });
  }

  hideBundlePrice();

  // Re-run after collection updates / infinite scroll
  new MutationObserver(hideBundlePrice).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// js code for single/pair on quick view modal

(function () {
  if (window.__apiPairDropdownLoaded) return;

  window.__apiPairDropdownLoaded = true;

  function getProductForm(dropdown) {
    const formId = dropdown?.dataset.productFormId;

    if (!formId) return null;

    return document.getElementById(formId);
  }

  function getSelectedVariantId(dropdown) {
    const productForm = getProductForm(dropdown);

    if (!productForm) return null;

    const variantInput = productForm.querySelector(
      'input[name="id"].product-variant-id, input[name="id"]'
    );

    return variantInput?.value || null;
  }

  function refreshVariantPrices(dropdown) {
    const variantId = getSelectedVariantId(dropdown);

    if (!variantId) return;

    const variantPrice = dropdown.querySelector(
      `[data-pair-variant-price][data-variant-id="${variantId}"]`
    );

    if (!variantPrice) return;

    dropdown.dataset.singlePrice =
      variantPrice.dataset.singlePrice;

    dropdown.dataset.pairComparePrice =
      variantPrice.dataset.pairComparePrice;

    dropdown.dataset.pairDiscountPrice =
      variantPrice.dataset.pairDiscountPrice;

    const singleRadio = dropdown.querySelector(
      '[data-pair-radio][value="1"]'
    );

    const pairRadio = dropdown.querySelector(
      '[data-pair-radio][value="2"]'
    );

    const singleOptionPrice = singleRadio
      ?.closest('.api-pair-option')
      ?.querySelector('[data-pair-option-price]');

    const pairOptionPrice = pairRadio
      ?.closest('.api-pair-option')
      ?.querySelector('[data-pair-option-price]');

    if (singleOptionPrice) {
      singleOptionPrice.textContent =
        variantPrice.dataset.singlePrice;
    }

    if (pairOptionPrice) {
      pairOptionPrice.innerHTML = `
        <s>${variantPrice.dataset.pairComparePrice}</s>
        ${variantPrice.dataset.pairDiscountPrice}
      `;
    }
  }

  function updateQuantity(dropdown, quantity) {
    const productForm = getProductForm(dropdown);

    if (!productForm) return;

    const quantityInput = productForm.querySelector(
      'input[name="quantity"]:not([type="radio"])'
    );

    if (!quantityInput) {
      console.warn(
        'Quick-add quantity input was not found:',
        dropdown.dataset.productFormId
      );

      return;
    }

    const nextQuantity = String(quantity);

    /*
     * Shopify reads this value when the form is submitted.
     * Do not dispatch input/change events here because the
     * theme may interpret them as variant changes.
     */
    quantityInput.value = nextQuantity;
    quantityInput.setAttribute('value', nextQuantity);
  }

  function updateMainPrice(dropdown, selection) {
    const productInfo = dropdown.closest('product-info');

    if (!productInfo) return;

    const priceElement = productInfo.querySelector(
      '.product__price .price__sale .price-item--sale, ' +
      '.product__price .price__regular .price-item--regular'
    );

    if (!priceElement) return;

    const singlePrice = dropdown.dataset.singlePrice;
    const pairComparePrice =
      dropdown.dataset.pairComparePrice;

    const pairDiscountPrice =
      dropdown.dataset.pairDiscountPrice;

    if (selection === 'pair') {
      priceElement.innerHTML = `
        <s class="api-pair-compare-price">
          ${pairComparePrice}
        </s>

        <span class="api-pair-discount-price">
          ${pairDiscountPrice}
        </span>
      `;
    } else {
      priceElement.innerHTML = `
        <span>${singlePrice}</span>
      `;
    }
  }

  function updateSelectedStyle(dropdown, selectedRadio) {
    dropdown
      .querySelectorAll('.api-pair-option')
      .forEach(function (option) {
        const optionRadio = option.querySelector(
          '[data-pair-radio]'
        );

        option.classList.toggle(
          'is-selected',
          optionRadio === selectedRadio
        );
      });
  }

  function applySelection(dropdown, radio) {
    if (!dropdown || !radio) return;

    /*
     * Load prices belonging to the currently selected
     * Shopify product variant.
     */
    refreshVariantPrices(dropdown);

    const quantity = Number(radio.value) || 1;
    const selection =
      quantity === 2 ? 'pair' : 'single';

    updateQuantity(dropdown, quantity);
    updateMainPrice(dropdown, selection);
    updateSelectedStyle(dropdown, radio);

    const summary = dropdown.querySelector(
      '[data-pair-summary]'
    );

    if (summary) {
      summary.textContent =
        radio.dataset.label || 'Single';
    }
  }

  function reapplyCurrentSelection(productInfo) {
    if (!productInfo?.isConnected) return;

    const dropdown = productInfo.querySelector(
      '[data-pair-dropdown]'
    );

    if (!dropdown) return;

    const selectedRadio = dropdown.querySelector(
      '[data-pair-radio]:checked'
    );

    if (!selectedRadio) return;

    applySelection(dropdown, selectedRadio);
  }

  function scheduleVariantPriceUpdate(productInfo) {
    /*
     * Different themes complete their variant updates at
     * different times. These delayed checks run after the
     * theme has updated the selected variant and price.
     */
    [50, 150, 350, 600].forEach(function (delay) {
      setTimeout(function () {
        reapplyCurrentSelection(productInfo);
      }, delay);
    });
  }

  function initializePairDropdown(dropdown) {
    if (!dropdown) return;

    if (
      dropdown.dataset.pairInitialized === 'true'
    ) {
      return;
    }

    const pairRadio = dropdown.querySelector(
      '[data-pair-radio][value="2"]'
    );

    if (!pairRadio) return;

    dropdown.dataset.pairInitialized = 'true';

    /*
     * Pair is selected by default.
     */
    pairRadio.checked = true;

    requestAnimationFrame(function () {
      applySelection(dropdown, pairRadio);
    });

    /*
     * Run again after the AJAX quick-add form has
     * completely finished rendering.
     */
    setTimeout(function () {
      applySelection(dropdown, pairRadio);
    }, 100);
  }

  function initializeAllPairDropdowns(root) {
    const scope = root || document;

    if (scope.matches?.('[data-pair-dropdown]')) {
      initializePairDropdown(scope);
    }

    scope
      .querySelectorAll?.('[data-pair-dropdown]')
      .forEach(initializePairDropdown);
  }

  /*
   * Handle manual Single/Pair selection.
   */
  document.addEventListener('change', function (event) {
    const radio = event.target.closest(
      '[data-pair-radio]'
    );

    if (!radio) return;

    const dropdown = radio.closest(
      '[data-pair-dropdown]'
    );

    if (!dropdown) return;

    applySelection(dropdown, radio);
    dropdown.removeAttribute('open');
  });

  /*
   * Reapply Pair pricing only when a real product
   * variant option changes.
   */
  document.addEventListener('change', function (event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const isVariantControl = target.matches(
      [
        '.swatch-input__input',
        '[data-product-option]',
        'select[name^="options"]',
        'input[name^="options"]',
        'input[name^="Color-"]',
        'input[name^="Colour-"]'
      ].join(',')
    );

    if (!isVariantControl) return;

    const productInfo = target.closest('product-info');

    if (!productInfo) return;

    if (
      !productInfo.querySelector('[data-pair-dropdown]')
    ) {
      return;
    }

    scheduleVariantPriceUpdate(productInfo);
  });

  /*
   * Support theme-specific variant events.
   */
  [
    'variant:change',
    'variant:changed',
    'product:variant-change'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      const eventTarget = event.target;

      if (!(eventTarget instanceof Element)) return;

      const productInfo =
        eventTarget.closest('product-info');

      if (!productInfo) return;

      if (
        !productInfo.querySelector('[data-pair-dropdown]')
      ) {
        return;
      }

      scheduleVariantPriceUpdate(productInfo);
    });
  });

  /*
   * Initialize dropdowns already on the page.
   */
  initializeAllPairDropdowns(document);

  /*
   * Quick-add modal content is inserted through AJAX,
   * so initialize dropdowns when new content appears.
   */
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }

        initializeAllPairDropdowns(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
